import { Refetch, ListControllerProps } from "ra-core";
import { createContext } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { ClassificationRulesDisplayDto, ClassificationRuleDto, TrialResultStatisDto } from "@/gen/api/securefile";


export const ClassificationRulesContext = createContext<ClassificationRulesControllerProps>({} as any)

export interface ClassificationRulesControllerProps {
  record: (ClassificationRulesDisplayDto & RecPatch) | undefined;
  refetch: Refetch | undefined;
  listCtx: ListControllerProps<ClassificationRuleDto & RecPatch>;
  changePendingIds: Set<number>;
  allRules: ClassificationRuleDto[];
  currRuleSetItems: ClassificationRuleDto[];
  newRuleSetItems: ClassificationRuleDto[];
  ruleSetChangeExists: boolean;
  states: {
    SN: number | null;
    statisData: TrialResultStatisDto | null;
    statisRefresh: {
      trialId: number | null;
      timer: number | null;
      interval: number;
    }
  };
  updateSN(sn: number | null): void;
  updateTrialId(trialId: number, recordsCount: number): void;
}
